<template>
    <div>
        <Table border :columns="columns5" :data="data5">
            <template slot-scope="{ row ,index }" slot="heighten">
                <Input type="textarea" v-model="row.heighten" :autosize="true" @on-change="targetItemChange(row,index,'heighten')" />
            </template>
            <template slot-scope="{ row ,index }" slot="activesPerformed" style="width:100%">
                <Input type="textarea" v-model="row.activesPerformed" :autosize="true" @on-change="targetItemChange(row,index,'activesPerformed')"/>
            </template>
            <template slot-scope="{ row ,index }" slot="completeDate" style="width:100%">
                <Input type="textarea" v-model="row.completeDate" :autosize="true" @on-change="targetItemChange(row,index,'completeDate')"/>
            </template>
            <template slot-scope="{ row,index }" slot="startDate">
               <DatePicker type="date" v-model="row.startDate" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'startDate')"/>
            </template>
            <template slot-scope="{ row,index }" slot="endDate">
                <DatePicker type="date" v-model="row.endDate" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'endDate')"/>
            </template>
            <template slot-scope="{ row,index }" slot="complete">
                <Input type="textarea" v-model="row.complete" :autosize="true" @on-change="targetItemChange(row,index,'complete')"/>
            </template>
            <template slot-scope="{ row, index }" slot="action5">
                <Button icon="md-trash" type="warning" size="small" @click="deletePlan(index,row)"></Button>
            </template>
        </Table>
        <div style="display: flex; justify-content: flex-end; margin-top:10px">
            <Button @click="addPlan()">新增</Button>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            columns5: [
                {
                    title: "发展目标",
                    slot: "heighten",
                    align: "center",
                },
                {
                    title: "详情描述",
                    slot: "activesPerformed",
                    align: "center",
                },
                {
                    title: "胜任力",
                    slot: "completeDate",
                    align: "center",
                },{
                    title: "开始日期",
                    slot: "startDate",
                    align: "center",
                },{
                    title: "结束日期",
                    slot: "endDate",
                    align: "center",
                },{
                    title: "发展活动",
                    slot: "complete",
                    align: "center",
                },
                {
                    title: "操作",
                    slot:"action5",
                    align: "center",
                    width: "100",
                },
            ],
            data5:[],
        }
    },
    methods:{
        editPlan(row, index){
            this.openPlan = true
            this.formItem5 = {...row}
            this.planAction = 2;
            this.planActionIndex = index
        },
        deletePlan(index,row){
            this.data5.splice(index, 1);
        },
        addPlan(){
            this.data5.push({heighten:'',activesPerformed:'',completeDate:'',startDate:'',endDate:'',complete:''})
        },
        targetItemChange(row,index,val,key){
            key=='heighten'?this.$set(this.data1[index],'heighten',row.heighten):''
            key=='activesPerformed'?this.$set(this.data1[index],'activesPerformed',row.activesPerformed):''
            key=='completeDate'?this.$set(this.data1[index],'completeDate',row.completeDate):''
            key=='startDate'?this.$set(this.data1[index],'startDate',row.startDate):''
            key=='endDate'?this.$set(this.data1[index],'endDate',row.endDate):''
            key=='complete'?this.$set(this.data1[index],'complete',row.complete):''
        
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/Apply/components/DevelopmentPlan.vue